import { render, staticRenderFns } from "./AddAttributeMaster.vue?vue&type=template&id=6995872a&scoped=true"
import script from "./AddAttributeMaster.vue?vue&type=script&lang=js"
export * from "./AddAttributeMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6995872a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6995872a')) {
      api.createRecord('6995872a', component.options)
    } else {
      api.reload('6995872a', component.options)
    }
    module.hot.accept("./AddAttributeMaster.vue?vue&type=template&id=6995872a&scoped=true", function () {
      api.rerender('6995872a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/managment/AddAttributeMaster.vue"
export default component.exports